export const isYesOrTrue = (configProp: string | boolean | number): boolean => {
    return (
        configProp === true ||
        configProp === "Yes" ||
        configProp === "yes" ||
        configProp === 1 ||
        configProp === "True" ||
        configProp === "true"
    );
};